import { numericFormatter } from "react-number-format";
import { columns } from "../../../dtos/columns";
import AccionesGarantias from "../components/garantias/accionesGarantias";
import { garantias, listaGarantias } from "../models/garantias";
import { IsDesactivado } from "../services/servicesMutuo";

export function useColumnsGarantias(idMutuo: number, isDesactivado: boolean , obtenerGarantias: (idMutuo: number, idGarantias: number) => Promise<void>, setShow: React.Dispatch<React.SetStateAction<boolean>>, renderizar: () => Promise<void>, isComplementario: boolean, esVigente?: boolean) {

    const COLUMNS: columns<listaGarantias>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            sortable: true,
            wrap: true,
            export: false,
            cell: (row) => <AccionesGarantias
                idGarantias={row.idGarantias}
                idMutuo={idMutuo}
                obtenerGarantias={obtenerGarantias}
                setShow={setShow}
                garantias={row}
                renderizar={renderizar}
                isComplementario={isComplementario}
                isDesactivado={isDesactivado}
                esVigente={esVigente}
            />,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Rol',
            selector: (row) => row.rol,
            sortable: true,
            sortField: 'rol',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Tipo bien raíz',
            selector: (row) => row.tipoBienRaiz,
            sortable: true,
            sortField: 'tipoBienRaiz',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Descripción garantía',
            selector: (row) => row.descripcionGarantia,
            sortable: true,
            sortField: 'descripcionGarantia',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Valor garantía',
            selector: (row) => row.valorGarantia,
            cell: (row) => numericFormatter(row.valorGarantia.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorGarantia',
            wrap: true,
            export: true,
            right: true
        },
        {
            name: 'Valor liquidación',
            selector: (row) => row.valorLiquidacion,
            cell: (row) => numericFormatter(row.valorLiquidacion.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'valorLiquidacion',
            wrap: true,
            export: true,
            right: true
        },
        {
            name: 'Tipo hipoteca',
            selector: (row) => row.tipoHipoteca ?? 0,
            sortable: true,
            sortField: 'tipoHipoteca',
            wrap: true,
            export: true,
            center: true,
        },
        {
            name: 'Estado bien raíz',
            selector: (row) => row.estadoBienRaiz ?? 0,
            sortable: true,
            sortField: 'estadoBienRaiz',
            wrap: true,
            export: true,
            center: true,
        },
    ];

    return { COLUMNS };
}